import React, { useState } from 'react';
import '../../Styles/Program.css'; // Import the CSS file

import ProgramsTab from './ProgramsTab/ProgramTable';
import DesignationTab from './Designation/DesignationTable';
import DepartmentTab from './Department/DepartmentTable';
import SemesterTab from './Semester/SemesterTable';
import SubjectTab from './Subject/SubjectTable';

const TAB_OPTIONS = [
  { key: 'Programs', label: 'Programs', icon: '📚' },
  { key: 'Designation', label: 'Designation', icon: '👔' },
  { key: 'Department', label: 'Department', icon: '🏢' },
  { key: 'Semester', label: 'Semester', icon: '📅' },
  { key: 'Subject', label: 'Subject', icon: '📖' }
];

const tabComponents = {
  Programs: ProgramsTab,
  Designation: DesignationTab,
  Department: DepartmentTab,
  Semester: SemesterTab,
  Subject: SubjectTab,
};

const Programs = () => {
  const [activeTab, setActiveTab] = useState('Programs');
  const ActiveComponent = tabComponents[activeTab];

  return (
    <div className="program-page-container">
      {/* Header */}
      <div className="program-page-header">
        <div className="program-page-header-left">
          <div>
            <h1 className="program-page-title">Programs Management</h1>
            <p className="program-page-subtitle">Manage programs, designations, departments, semesters, and subjects</p>
          </div>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="program-tab-navigation">
        {TAB_OPTIONS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`program-tab-button ${
              activeTab === tab.key ? 'program-tab-button-active' : ''
            }`}
          >
            <span className="program-tab-icon">{tab.icon}</span>
            <span className="program-tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="program-tab-content">
        <ActiveComponent />
      </div>
    </div>
  );
};

export default Programs;
